import NdMessage from 'app/message/message';
import { t } from 'app/libWrappers/i18next.wrapper';
import $ from 'jquery';
import _ from 'underscore';

const DASHBOARD_API_URL = '/api/1_0/dashboards';
const TAG_API_URL = '/api/1_0/tags';
const FEED_API_URL = '/api/1_0/feeds';
const TREE_API_URL = '/api/1_0/tree';
const EXPORT_API_URL = '/api/1_0/export';
const NEWSLETTERS_API_URL = '/api/1_0/alerts';
const CHART_API_URL = '/api/1_0/charts';
const ARTICLE_API_URL = '/api/1_0/articles';
const PUBLIC_CHART_API_URL = '/api/1_0/publicCharts';
const AVAILABLE_EMAIL_LICENSES_API_URL = '/api/1_0/alerts/availableEmailLicenses';
const DEFAULT_EMAIL_THEME_ID_API_URL = '/api/1_0/emailThemes/defaultThemeId';
const RSS_FEED_API_URL = '/api/1_0/rssFeeds';
const EMAIL_SUBSCRIPTIONS_API_URL = '/api/1_0/emailSubscription';
const GROUP_API_URL = '/api/1_0/group';
const FAVORITES_API_URL = '/api/1_0/userFavorites';
const SOURCES_API_URL = '/api/1_0/sources';
const USER = '/api/1_0/user/';
const USER_SUBSCRIPTIONS = '/api/1_0/emailProfiles/userSubscriptions';
const AVAILABLE_FEEDS = '/api/1_0/tree/availableFeeds';
const SMART_INDEXES = '/api/1_0/smartIndexes';

export default {
    ENDPOINT: {
        DASHBOARDS: DASHBOARD_API_URL,
        TAGS: TAG_API_URL,
        TREE: TREE_API_URL,
        SEARCH: FEED_API_URL,
        NEWSLETTERS: NEWSLETTERS_API_URL,
        AVAILABLE_EMAIL_LICENSES: AVAILABLE_EMAIL_LICENSES_API_URL,
        DEFAULT_EMAIL_THEME_ID: DEFAULT_EMAIL_THEME_ID_API_URL,
        FEED_QUERIES: `${FEED_API_URL}/feedQueries`,
        EXPORTS: EXPORT_API_URL,
        RSS_FEED: RSS_FEED_API_URL,
        GROUP: GROUP_API_URL,
        CUSTOMER_PUBLIC_GROUPS: GROUP_API_URL + '/public',
        FAVORITES: FAVORITES_API_URL,
        SOURCES: SOURCES_API_URL,
        USER: USER,
        USER_SUBSCRIPTIONS: USER_SUBSCRIPTIONS,
        AVAILABLE_FEEDS: AVAILABLE_FEEDS,
        SMART_INDEXES: SMART_INDEXES,

        charts: (chartId) => {
            return `${CHART_API_URL}/${chartId}`;
        },

        chartFeeds: (chartId, feedIds) => {
            return `${CHART_API_URL}/${chartId}/feeds/${feedIds}`;
        },

        chartExcludedValues: (chartId) => {
            return `${CHART_API_URL}/${chartId}/excludedValues`;
        },

        feeds: {
            updateDescription: (feedId) => {
                return `${FEED_API_URL}/simpleFeed/updateDescription/${feedId}`;
            },
            renameFeed: (feedId) => {
                return `${FEED_API_URL}/simpleFeed/${feedId}`;
            },
            feed: (feedId) => {
                return `${FEED_API_URL}/${feedId}`;
            },
            details: (feedId) => {
                return `${FEED_API_URL}/${feedId}/details`;
            }
        },

        articlesForSearch: (params = {}) => {
            let { ...paramsToUse } = { ...params, purpose: params.searchPurpose };
            paramsToUse = _.pick(paramsToUse, [
                'feedId',
                'purpose',
                'start',
                'size',
                'useCache',
                'sortBy',
                'fromDateMillis',
                'triggerEvent',
                'isQuickSearch',
                'quickSearchWorkflow',
                'includeArticlesClipped'
            ]);
            let parameters = $.param(paramsToUse);

            return `/api/1_0/articles?${parameters}`;
        },

        searchAssistantEntities: (search, includeEntities, includeIndexTerms, internationalOnly) => {
            const encodedSearch = encodeURIComponent(search);
            return `/api/1_0/searchAssistant/suggest/entities?search=${encodedSearch}&includeEntities=${includeEntities}&includeIndexTerms=${includeIndexTerms}&internationalOnly=${internationalOnly}`;
        },

        facetConfiguration: (configurationType) => {
            return `/api/1_0/facetConfigurations/${configurationType}`;
        },

        facetAdditionalInformation: (facetType) => {
            return `/api/1_0/facets/additionalInformation/${facetType}`;
        },

        facetsForSearch: (params = {}) => {
            let parameters = $.param(params);
            return `/api/1_0/facet?${parameters}`;
        },

        facetsForSources: (params = {}) => {
            let parameters = $.param(params);
            return `/api/1_0/sourcesIndex/facetsWithRefine?${parameters}`;
        },

        feedArticles: (feedId) => {
            return `${TREE_API_URL}/feed-${feedId}/articles`;
        },

        feedArticlesComments: (articleId, commentId) => {
            return `/api/1_0/articles/${articleId}/comments/${commentId}`;
        },

        dashboardWidgets: (dashboardId) => {
            return `${DASHBOARD_API_URL}/${dashboardId}/widgets`;
        },

        dashboardWidget: (dashboardId, widgetId) => {
            return `${DASHBOARD_API_URL}/${dashboardId}/widgets/${widgetId}`;
        },

        dashboardWidgetOptions: (dashboardId, widgetId) => {
            return `${DASHBOARD_API_URL}/${dashboardId}/widgets/${widgetId}/options`;
        },

        dashboardWidgetLayouts: (dashboardId) => {
            return `${DASHBOARD_API_URL}/${dashboardId}/widgets/layouts`;
        },

        selectedDashboard: (dashboardId) => {
            return `${DASHBOARD_API_URL}/selected/${dashboardId}`;
        },

        articleTags: (articleIds, tagIds) => {
            let articleIdsJoined = articleIds.join(',');
            let tagIdsJoined = tagIds.join(',');
            return `${TAG_API_URL}/articles/?articleIds=${articleIdsJoined}&tagIds=${tagIdsJoined}`;
        },

        feedTags: (feedId, tagId) => {
            return `${TAG_API_URL}/feed/${feedId}/tag/${tagId}`;
        },

        tagsMappedToArticleIds: (articleIds) => {
            //converts ArticleIds to a hexadecimal string param
            let articlesIdsHex = articleIds.map((articleId) => Number(articleId).toString(16)).join('|'); //eslint-disable-line no-magic-numbers
            return `${TAG_API_URL}/articles/?articleIdsHex=${articlesIdsHex}`;
        },

        usersExports: () => {
            return `${EXPORT_API_URL}/userinfo`;
        },

        exportedFeed: (feedId) => {
            return `${EXPORT_API_URL}/feed/${feedId}`;
        },

        exportedFeeds: (feedIds) => {
            let commaSeperatedFeedIds = feedIds.join(',');
            return `${EXPORT_API_URL}/feeds?ids=${commaSeperatedFeedIds}`;
        },

        sources: (params = {}) => {
            let parameters = $.param(params);
            return `/api/1_0/sources?${parameters}`;
        },

        sourceInfo: (params) => `/api/1_0/sourcesIndex/sourceInfo?${$.param(params)}`,

        archivedFeeds: '/api/1_0/archive/',
        archivedFeedsSummary: '/api/1_0/archive/info',
        archivedFeed: (feedId) => {
            // Use GET to get archived feed metadata
            // Use PUT or DELETE to add or remove from archive, respectively
            return '/api/1_0/archive/' + feedId;
        },

        archiveArticle: (articleId) => `/api/1_0/archive/article/${articleId}`, // POST

        publicGroupMembership: (groupId) => `${GROUP_API_URL}/${groupId}/myMembership` // PUT or DELETE
    },

    getSourceDetails: (sourceIds, sourceFeedIds) => {
        return $.ajax({
            url: SOURCES_API_URL + '/lookup',
            type: 'POST',
            data: JSON.stringify({ sourceIds, sourceFeedIds }),
            headers: { 'Content-Type': 'application/json' }
        });
    },
    editRssSource: (feedId, url, feedTitle) => {
        return $.ajax({
            url: RSS_FEED_API_URL,
            type: 'PUT',
            data: JSON.stringify({ feedId: feedId, url: url, feedTitle: feedTitle }),
            headers: { 'Content-Type': 'application/json' }
        });
    },
    loadRssSource: (feedId) => {
        return $.ajax({
            url: `${RSS_FEED_API_URL}/${feedId}`,
            type: 'GET',
            headers: { 'Content-Type': 'application/json' }
        });
    },
    deleteRssSource: (feedId) => {
        return $.ajax({
            url: RSS_FEED_API_URL,
            type: 'DELETE',
            data: JSON.stringify({ feedId: feedId }),
            headers: { 'Content-Type': 'application/json' }
        });
    },

    pauseEmailSources: (sourcesToPause) => {
        return $.ajax({
            url: `${EMAIL_SUBSCRIPTIONS_API_URL}/pauseMultiple`,
            data: JSON.stringify(sourcesToPause),
            type: 'POST',
            headers: { 'Content-Type': 'application/json' }
        });
    },

    resumeEmailSources: (sourcesToResume) => {
        return $.ajax({
            url: `${EMAIL_SUBSCRIPTIONS_API_URL}/resumeMultiple`,
            data: JSON.stringify(sourcesToResume),
            type: 'POST',
            headers: { 'Content-Type': 'application/json' }
        });
    },

    editEmailSubscriptionSource: (sourceId, sourceName, sourceNotes, sourceOwner) => {
        return $.ajax({
            url: `${EMAIL_SUBSCRIPTIONS_API_URL}/updateEmailSubscriptionSource?sourceId=${sourceId}&sourceName=${encodeURIComponent(
                sourceName
            )}&sourceNotes=${encodeURIComponent(sourceNotes)}&sourceOwner=${encodeURIComponent(sourceOwner)}`,
            type: 'POST',
            headers: { 'Content-Type': 'application/json' }
        });
    },

    CONTENT_TYPE_JSON: 'application/json; charset=UTF-8',

    SEARCH_PURPOSE: {
        WIDGET: 'WIDGET'
    },

    getChartSeriesData: (dataForServer, chartId, origin, code, codeCheck) => {
        const isPublic = origin === 'Embed' || origin === 'Email';
        const seriesDataUrl = isPublic
            ? `${PUBLIC_CHART_API_URL}/${chartId}/seriesData?${$.param({ code, origin, codeCheck })}`
            : `${CHART_API_URL}/generateSeriesData`;
        return $.ajax({
            url: seriesDataUrl,
            type: 'POST',
            data: JSON.stringify(dataForServer),
            contentType: 'application/json; charset=UTF-8'
        });
    },

    getSeriesDataAndSpikes: (dataForServer) => {
        return $.ajax({
            url: `${CHART_API_URL}/generateSeriesDataAndSpikes`,
            type: 'POST',
            data: JSON.stringify(dataForServer),
            contentType: 'application/json; charset=UTF-8'
        });
    },

    getAlertsInfo: (alertId) => {
        return $.ajax({
            url: `${NEWSLETTERS_API_URL}/info/${alertId}`,
            type: 'GET',
            contentType: 'application/json; charset=UTF-8'
        });
    },

    getArticleDownloadHeaderSections: () => {
        return $.ajax({
            url: `${ARTICLE_API_URL}/articleExportHeaders`,
            type: 'GET',
            contentType: 'application/json; charset=UTF-8'
        });
    },

    getFeedInfo: (feedId) => {
        return $.ajax({
            url: `${FEED_API_URL}/${feedId}`,
            type: 'GET',
            contentType: 'application/json; charset=UTF-8'
        });
    },

    sendMetrics: (metrics) => {
        return $.ajax({
            url: '/api/1_0/metric',
            type: 'POST',
            data: JSON.stringify(metrics),
            contentType: 'application/json; charset=UTF-8'
        });
    },

    handleError: function (error, messagePrefix, defaultMessage) {
        console.error('Ajax Error:', error); // eslint-disable-line no-console

        const fallbackMessage = defaultMessage ? defaultMessage : t('common:requestError');
        NdMessage.handleErrorResponse(messagePrefix, error, fallbackMessage);
    },

    handleSuccess: function (message) {
        NdMessage.showSuccess(message);
    },

    handleNewsletterSpecificErrorMessages: function (error, prefix) {
        const errorAdditionalInformation = error.responseJSON.errorAdditionalInformation;
        const errorKey = error.responseJSON.errorKey;
        if (errorAdditionalInformation.invalidRecipients) {
            let invalidRecipients = errorAdditionalInformation.invalidRecipients;
            let messageKey = `${prefix}${errorKey}`;
            NdMessage.showError(
                t(messageKey, {
                    count: invalidRecipients.length,
                    invalidRecipients: invalidRecipients.join(', ')
                })
            );
        } else {
            NdMessage.handleErrorResponse(prefix, error);
        }
    }
};
